import { useSettingsContext } from "../../hook/useSettingsContext";
import { Save } from "lucide-react";

export default function SaveButton() {
    const { handleSubmit, loading, hasChanges } = useSettingsContext();

    return (
        <div
            className={`sticky bottom-0 z-40 backdrop-blur-md bg-white/60 border-t border-gray-200 transition-all duration-300 ease-in-out ${
                hasChanges
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-4 pointer-events-none"
            }`}
        >
            <div className="flex py-4 px-8 max-wp:px-4">
                <button
                    onClick={handleSubmit}
                    className="inline-flex items-center gap-2 h-11 px-5 bg-blue-600 hover:bg-blue-700 text-white font-medium text-sm rounded-lg transition-colors"
                >
                    {loading.updateSettings ? (
                        <>
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                            Saving...
                        </>
                    ) : (
                        <>
                            <Save className="w-4 h-4" />
                            Save Changes
                        </>
                    )}
                </button>
            </div>
        </div>
    );
}
